export const routes = {
	home: '/',
}